<div class="last-records">
    <div class="last-records-title">{{title}}</div>
  
    <div class="scrollbar last-questionnaire-scrollbar" id="style-1">
      <div class="last-records-content">
  
        <ng-content></ng-content>
  
      </div>
    </div>
  
</div>
  